import AutoSizerImplementation from './implementation/AutoSizerImplementation';
var AutoSizerComponent = AutoSizerImplementation;
export default AutoSizerComponent;
//# sourceMappingURL=AutoSizerComponent.js.map